const COLOR1 = '#5F3D85'
const COLOR2 = '#AA4DDE'
const COLOR3 = '#F97C7D'
const COLOR4 = '#FBA4B4'
const COLOR5 = '#FADBFA'
const COLOR6 = '#3F5DD8'
const COLOR7 = '#3984FF'
const COLOR8 = '#CBF8C6'
const COLOR9 = '#7AFD79'

export const AVATAR_COLORS = [COLOR1, COLOR2, COLOR3, COLOR4, COLOR5, COLOR6, COLOR7, COLOR8, COLOR9]

export const COLORS_WITH_BLACK_TEXT = [COLOR4, COLOR5, COLOR8, COLOR9]
